<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                        <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                        <div class="flex-1">
                            <h3 class="m-0">Log Aktifitas</h3>
                            <p class="mb-0">Berikut rincian aktifitas akun anda ya gan :)</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                <th>Tanggal</th>
                                <th>Aktifitas</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in Get.data.list">
                                        <td>
                                            <span style="text-transform: uppercase;"><strong>{{ u.kategori }}</strong></span><br>
                                            <span>{{ myGlobal.tglIndo(u.tanggal) }}</span> - <span>{{ myGlobal.jamIndo(u.jam) }}</span>
                                        </td>
                                        <td>{{u.text}}</td>
                                    </tr>

                                    <tr v-show="Get.data.list.length == 0">
                                        <td></td>
                                        <td>Tidak ada Data</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/InterfaceBelog' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
        params: '',
        historyUpgrade: true,
        kangtagih: null,
    })

	const Get = {
      	data: reactive({
            list: [],
            listBayar: []
      	}),
		baca() {
			var datac = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
                mid: data.params.mid,
        	};
				
			var apiUrl = inter.baca();
			myGlobal.callBelog(datac,apiUrl).then(x => {

                //console.log(JSON.stringify(x));

				if (x.status == true) {
                    Get.data.list = x.data
				} else {
					//alert(x.pesan);
				}
			})
		},
    }
    return {
      data,
      myGlobal,
      Get
    }

  },
  mounted () {

    document.title = "Log Aktifitas"; 

    //console.log(JSON.stringify(this.data.params));

    this.Get.baca();

  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/log-act/main.vue